/**
 * Utilitários para detecção e interação com Android
 */

/**
 * Função para detectar se a aplicação está rodando em um WebView Android
 * @returns {boolean} true se estiver em Android, false caso contrário
 */
export const isAndroid = () => {
  return typeof window !== 'undefined' && !!window.Android;
};

/**
 * Função para abrir configurações Android
 * Chama a função nativa do Android se disponível
 */
export const openConfig = () => {
  try {
    if (isAndroid()) {
      window.Android.openConfig();
    } else {
      alert('Função disponível apenas em dispositivos Android');
    }
  } catch (e) {
    console.error('Erro ao abrir configurações Android:', e);
    alert('Função disponível apenas em dispositivos Android');
  }
};

/**
 * Função para verificar se uma função específica do Android está disponível
 * @param {string} functionName - Nome da função a ser verificada
 * @returns {boolean} true se a função estiver disponível
 */
export const isAndroidFunctionAvailable = (functionName) => {
  return isAndroid() && typeof window.Android[functionName] === 'function';
};